import React from "react";
import { Modal, Button } from "react-bootstrap";
import { backBtnIcon } from "../../icon/icon";

const PhotoModal = (props) => {
  const { takeDetailsModal, selfieData, onErase, onSubmit, ...rest } = props;
  return (
    <Modal
      {...rest}
      centered
      size="lg"
      contentClassName="use-photo-container"
      className={takeDetailsModal && "d-none"}
    >
      <Modal.Header closeButton className="use-photo-header">
        <span role="button" onClick={props.onHide}>
          {backBtnIcon}
        </span>
        <span className="use-photo-title">Use Photo</span>
      </Modal.Header>
      <Modal.Body className="use-photo-image-wrapper">
        <img src={selfieData} alt="Selected" className="use-photo-image" />
      </Modal.Body>
      <Modal.Footer className="use-photo-btn-row">
        <Button
          type="button"
          variant="danger"
          className="btn"
          onClick={onErase}
        >
          ERASE
        </Button>
        <Button
          type="button"
          variant="primary"
          className="btn"
          onClick={onSubmit}
        >
          USE PHOTO
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default PhotoModal;
